"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoBar = void 0;
const react_1 = __importDefault(require("react"));
const react_markdown_1 = __importDefault(require("react-markdown"));
const remark_gfm_1 = __importDefault(require("remark-gfm"));
const icons_1 = require("../../../../theme/icons");
const forms_1 = require("../../../forms");
const global_1 = require("../../../global");
const InfoBar_styles_1 = require("./InfoBar.styles");
const InfoBar = ({ message, messageTranslationKey, secondaryText, secondaryTextTranslationKey, hasMarkdown, show, isAdmin, deleteHandler, editHandler, close, type, actionLabel, className, actionParams, actionClick, isAlwaysVisible, translationEditHandler, translationKey, }) => (
// @ts-expect-error Handle later
react_1.default.createElement(InfoBar_styles_1.Wrapper, { "$type": type, "$show": show },
    react_1.default.createElement(InfoBar_styles_1.Content, null,
        react_1.default.createElement(InfoBar_styles_1.Label, { "$type": type, "$inlineTranslation": !!translationKey }, !!messageTranslationKey ? (react_1.default.createElement(forms_1.EditableTitle, { name: message, editHandler: (isCancelled, value) => translationEditHandler && value && translationEditHandler(isCancelled, value, messageTranslationKey), isEditable: !!messageTranslationKey })) : (message)),
        secondaryText &&
            (hasMarkdown ? (react_1.default.createElement(react_markdown_1.default, { children: secondaryText, remarkPlugins: [remark_gfm_1.default] })) : (react_1.default.createElement(InfoBar_styles_1.SecondaryText, { "$type": type, "$inlineTranslation": !!translationKey }, !!secondaryTextTranslationKey ? (react_1.default.createElement(forms_1.EditableTitle, { name: secondaryText, editHandler: (isCancelled, value) => translationEditHandler &&
                    value &&
                    translationEditHandler(isCancelled, value, secondaryTextTranslationKey), isEditable: !!secondaryTextTranslationKey })) : (secondaryText))))),
    actionLabel && (react_1.default.createElement(InfoBar_styles_1.ActionWrapper, null,
        react_1.default.createElement(InfoBar_styles_1.Separator, { "$type": type }, "|"),
        react_1.default.createElement(InfoBar_styles_1.Action, { "$type": type, onClick: () => {
                actionClick(actionParams);
                if (!isAlwaysVisible) {
                    close();
                }
            }, className: className }, actionLabel))),
    !isAdmin && (react_1.default.createElement(InfoBar_styles_1.CrossStyle, { onClick: close },
        react_1.default.createElement(icons_1.Close, null))),
    isAdmin && (react_1.default.createElement(InfoBar_styles_1.IconContainer, null,
        react_1.default.createElement(global_1.IconWrapper, { width: 10, height: 10, hoverEffect: true, onClick: () => {
                if (deleteHandler)
                    deleteHandler();
            } },
            react_1.default.createElement(icons_1.Delete, null)),
        react_1.default.createElement(global_1.IconWrapper, { width: 10, height: 10, hoverEffect: true, onClick: () => {
                if (editHandler)
                    editHandler();
            } },
            react_1.default.createElement(icons_1.Edit, null))))));
exports.InfoBar = InfoBar;
//# sourceMappingURL=InfoBar.js.map